import React from 'react';
import { Box, Text, VStack, HStack, Icon } from '@chakra-ui/react';
import { FaStar } from 'react-icons/fa';

const TestimonialCard = ({ content, name, role, ...rest }) => {
  return (
    <Box
      bg="#0E2242"
      p={6}
      borderRadius="12px"
      border="1px solid"
      borderColor="rgba(255,255,255,0.10)"
      position="relative"
      transition="all 0.3s cubic-bezier(0.16, 1, 0.3, 1)"
      _hover={{
        borderColor: 'rgba(212,168,95,0.32)',
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 28px rgba(0,0,0,0.30)',
      }}
      {...rest}
    >
      {/* Gold quote-mark glyph */}
      <Text
        position="absolute"
        top={2}
        left={4}
        fontFamily="heading"
        fontSize="4xl"
        fontWeight={700}
        color="#D4A85F"
        opacity={0.4}
        lineHeight={1}
        pointerEvents="none"
        userSelect="none"
      >
        &ldquo;
      </Text>

      <VStack spacing={4} align="stretch" pt={6}>
        <Text
          fontFamily="body"
          fontSize="sm"
          color="#F5F7FA"
          lineHeight={1.7}
        >
          {content}
        </Text>

        {/* 5-star row in gold */}
        <HStack spacing={1}>
          {[0, 1, 2, 3, 4].map((i) => (
            <Icon key={i} as={FaStar} boxSize={3.5} color="#D4A85F" />
          ))}
        </HStack>

        <Box>
          <Text
            fontFamily="heading"
            fontWeight={500}
            fontSize="md"
            color="#F5F7FA"
            letterSpacing="-0.005em"
          >
            {name}
          </Text>
          <Text
            fontFamily="body"
            fontSize="xs"
            color="#9AA7B8"
            mt={0.5}
          >
            {role}
          </Text>
        </Box>
      </VStack>
    </Box>
  );
};

export default TestimonialCard;
